import {useEffect, useState} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';
import {FormDrawer} from '../drawers/FormDrawer';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useCustomer} from '../hooks/useCustomer.ts';
import {useCustomersSelection} from '../hooks/useCustomersSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';
import {Customer} from '../types';

export const EditPage = () => {

    const {id: customerId} = useParams();

    if (typeof customerId === 'undefined') {
        throw new Error('customerId is required parameter');
    }

    const {
        record: customer,
        loading,
        updateRecord,
        fetchRecord,
    } = useCustomer(customerId);

    const {handleClearSelection} = useCustomersSelection();

    const [drawerOpened, setDrawerOpened] = useState(false);

    const {tools} = useEditPageTools({onEdit: () => setDrawerOpened(true)});


    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || !customer) {
        return <PlatformLoader message='Loading customer...Please wait'/>;
    }

    const handleDrawerSubmit = (values: Customer) => {
        updateRecord(values);
    };

    return (
        <FormPageLayout
            title={customer.name ? customer.name : customer.id}
            pageNavigation={<EditPageNavigation component={customer}/>}
            tools={tools}
        >
            <Stack gap='lg'>
                <Profile
                    record={customer}
                    onRecordUpdate={() => {
                        fetchRecord();
                    }}
                />
            </Stack>

            <FormDrawer
                record={customer}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </FormPageLayout>
    );
};
